export default __webpack_public_path__ + "static/media/about-2.e76d6532.jpg";